import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FireflyListModule } from '../../../lists/list.module';
import { ModalContent } from '../../../modal';
import type { FireflyLocationSuggesterComponent } from '../../location-suggester.component';
import { SelectionType } from '../../models/selection-type.enum';
import { FireflyLocationChipGroupComponent } from '../location-chip-group/location-chip-group.component';
import { FireflyLocationHierarchyItemComponent } from '../location-hierarchy-item/location-hierarchy-item.component';

@Component({
  selector: 'f-location-suggester-mobile',
  templateUrl: './location-suggester-mobile.component.html',
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: true,
  imports: [CommonModule, FireflyListModule, FireflyLocationChipGroupComponent, FireflyLocationHierarchyItemComponent]
})
export class LocationSuggesterMobileComponent implements OnInit, ModalContent {
  context!: FireflyLocationSuggesterComponent;
  modalInstance!: NgbActiveModal;

  @ViewChild('inputEl') inputEl!: ElementRef<HTMLInputElement>;

  readonly SelectionType = SelectionType;

  ngOnInit(): void {
    window.requestAnimationFrame(() => this.inputEl?.nativeElement.focus());
  }
}
